import { createReducer, on } from '@ngrx/store';
import { setActiveClassIdStudent, setActiveGameCategoryId } from "../actions/student.actions";

export const studentFeatureKey = 'student';

export interface StudentState {
  activeGameCategoryId: number;
  activeClassId: string;
}

export const initialState: StudentState = {
  activeGameCategoryId: 0,
  activeClassId: ""
};

export const reducer = createReducer(
  initialState,
  on(setActiveGameCategoryId, (state, action) => {
    return {
      ...state,
      activeGameCategoryId: action.gameCategoryId
    }
  }),
  on(setActiveClassIdStudent, (state, action) => {
    return {
      ...state,
      activeClassId: action.classId
    }
  })
);
